import { User } from 'types';

declare global {
  interface Window {
    ym: (...args: unknown[]) => void;
  }
}

const YM_TRACK_ID = 68153041;

function track(...args: unknown[]) {
  if (import.meta.env.MODE !== 'production') return;
  try {
    window.ym(YM_TRACK_ID, ...args);
  } catch (e) {
    console.error(e);
  }
}

const hit = (path: string) => {
  track('hit', path);
};

const userParams = (params: User | null | undefined) => {
  if (!params) {
    track('userParams', {});
  } else {
    const { Id } = params;
    track('userParams', { UserID: Id, ...params });
  }
};

export const metrika = {
  hit,
  userParams,
};
